import { Grid, Slider } from "@material-ui/core";
import { Controller, useFormContext } from "react-hook-form";
import { TextField } from "../../../components/forms/text";
import { ErrorText } from "../../../store/launch-configurations/models/default-fields/common";
import { VerificationDTO } from "../../../store/verification/models/dto/due-diligence";

type RequestType = VerificationDTO.Requests.DueDiligence.Config.Post.T;

export function BackgroundColour() {
  const { control } = useFormContext<RequestType>();

  return (
    <>
      <Grid item xs={12} md={4}>
        <Controller
          control={control}
          name="header.css.backgroundColor.degree"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              fullWidth
              type="number"
              error={!!error}
              helperText={error?.message}
              label="Degree"
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Controller
          control={control}
          name="header.css.backgroundColor.end"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              type="color"
              fullWidth
              error={!!error}
              helperText={error?.message}
              label="End"
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <p>Start Alpha</p>
        <Controller
          control={control}
          name="header.css.backgroundColor.startAlpha"
          render={({ field, fieldState: { error } }) => (
            <>
              <Slider
                value={field.value}
                onChange={(_, value) => field.onChange(value)}
                orientation="horizontal"
                aria-labelledby="discrete-slider"
                valueLabelDisplay="off"
                step={1}
                min={0}
                max={100}
              />
              {error ? <ErrorText>{error.message}</ErrorText> : null}
            </>
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Controller
          control={control}
          name="header.css.backgroundColor.start"
          render={({ field, fieldState: { error } }) => (
            <TextField
              {...field}
              fullWidth
              type="color"
              error={!!error}
              helperText={error?.message}
              label="Start"
            />
          )}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <p>End Alpha</p>
        <Controller
          control={control}
          name="header.css.backgroundColor.endAlpha"
          render={({ field, fieldState: { error } }) => (
            <>
              <Slider
                value={field.value}
                onChange={(_, value) => field.onChange(value)}
                orientation="horizontal"
                aria-labelledby="discrete-slider"
                valueLabelDisplay="off"
                step={1}
                min={0}
                max={100}
              />
              {error ? <ErrorText>{error.message}</ErrorText> : null}
            </>
          )}
        />
      </Grid>
    </>
  );
}
